import * as React from 'react'
import { DefaultButton, Icon, IconButton, IIconProps, PrimaryButton } from 'office-ui-fabric-react';


interface IFunctionMenuButton {
    title: string;
    icon: string;
    link: string;
    onClick?(): void;
}

const FunctionMenuButton: React.FC<IFunctionMenuButton> = ({ title, icon, link, onClick }) => {

  const iconProps: IIconProps = { iconName: icon, styles: { root: { fontSize: 35, marginRight: '10px' } } };

  return (
    <div className='function-button-wrapper'>
        {/* <PrimaryButton  styles={{root:{width:'16em', height: '7em', borderRadius: '12px', backgroundColor: '#094AB2'}}} onClick={action}> */}
        <a href={link} style={{textDecoration: 'none'}}>
          <PrimaryButton 
            onClick={() => {
              if (onClick) {
                onClick();
              }
            }}
            styles={{root:{width: "100%", height: '7em', borderRadius: '12px', backgroundColor: '#1d4f90', marginRight: '0px'}}} iconProps={iconProps}
          >
              {/* <Icon iconName={icon} aria-hidden="true" style={{fontSize: '35px', marginRight: '10px'}}></Icon> */}
              <span className="ms-Button-label">{title}</span>
          </PrimaryButton>
        </a>
    </div>
  )
}

export default FunctionMenuButton